import { useMemo } from 'react';

import { PrimeIcons } from 'primereact/api';
import { Tag } from 'primereact/tag';
import { Link } from 'react-router-dom';

import { RequestEventFragment, RequestEventType } from '@/rtk-query.gql';

import { ICONS } from './constants';
import { useRelativeDate } from './useRelativeDate';

import './StatusUpdate.css';

export const StatusUpdate = ({
  event,
  requestId,
}: {
  event: RequestEventFragment;
  requestId: number;
}) => {
  const message = useMemo(() => {
    switch (event.type) {
      case RequestEventType.APPROVED:
        return 'approved this';
      case RequestEventType.COMPLETED:
        return 'closed this as completed';
      case RequestEventType.DENIED:
        return event.content ? (
          <>
            closed this as <Tag value={event.content} />
          </>
        ) : (
          'closed this as denied'
        );
      case RequestEventType.IN_PROGRESS:
        return 'marked this as in progress';
      default:
        return null;
    }
  }, [event.type, event.content]);
  const { absolute, showRelative, relative } = useRelativeDate(event.createdAt);
  if (!message) {
    return null;
  }

  if (requestId !== event.requestId) {
    // this event does not belong to this request
    // request was mentioned in other request
    return (
      <div className="border-wrapper" id={event.id.toString()}>
        <div className="border-wrapper__box">
          <div className="status">
            <span className="status__badge status__badge--mention">
              <i className={PrimeIcons.HASHTAG} />
            </span>
            <span className="status__message">
              <b>{event.author?.fullName ?? event.authorAdUserId}</b> mentioned
              this request in{' '}
              <Link to={`/issues/${event.requestId}#${event.id}`}>
                #{event.requestId}
              </Link>{' '}
              {showRelative ? (
                <span title={absolute}>{relative} ago</span>
              ) : (
                <span title={absolute}>on {absolute}</span>
              )}
            </span>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="border-wrapper" id={event.id.toString()}>
      <div className="border-wrapper__box">
        <div className="status">
          <span className="status__badge" data-event-type={event.type}>
            <i className={ICONS[event.type]} />
          </span>
          <span className="status__message">
            <b>{event.author?.fullName ?? event.authorAdUserId}</b> {message}{' '}
            {event.refRequestId ? (
              <>
                referencing{' '}
                <Link to={`/issues/${event.refRequestId}#${event.id}`}>
                  #{event.refRequestId}
                </Link>{' '}
              </>
            ) : null}
            {showRelative ? (
              <span title={absolute}>{relative} ago</span>
            ) : (
              <span title={absolute}>on {absolute}</span>
            )}
          </span>
        </div>
      </div>
    </div>
  );
};
